import { NgModule } from '@angular/core';

import { EChartsDirective } from './echarts.directive';
import { SlimScrollDirective } from './slim-scroll.directive';
import { FileDropDirective } from '../directives/file-drop';


@NgModule({
  imports: [],
  declarations: [
    EChartsDirective,
    SlimScrollDirective,
    FileDropDirective
  ],
  exports: [
    EChartsDirective,
    SlimScrollDirective,
    FileDropDirective
  ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/shared/shared.module.ts